/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from "react";
import { usePspApplePaySession } from "src/hooks/usePspApplePaySession";
import { useCartData } from "src/hooks/stores/use-cart-store";
import { Button } from "src/atoms/Button";

const ApplePayButton: React.FC<{
  label: string;
  paymentId?: string;
  buttonLoading?: boolean;
  onClickPay: (applePayToken: string) => void;
}> = ({ label, paymentId, buttonLoading, onClickPay }) => {
  const [applePaySession, setApplePaySession] = useState<any>();
  const [applePayLoading, setApplePayLoading] = useState(false);
  const [applePayPaymentSuccess, setApplePayPaymentSuccess] = useState(false);
  const { cart } = useCartData();

  const isProd = process.env.RELEASE_STAGE === "production";

  const { pspApplePaySession } = usePspApplePaySession({
    onCompleted: ({ pspApplePaySession }) => {
      if (!applePaySession) {
        return;
      }

      applePaySession.completeMerchantValidation(
        JSON.parse(pspApplePaySession.payment_session)
      );
    },
  });

  const cancelApplePay = () => {
    setApplePaySession(null);
    setApplePayLoading(false);
  };

  useEffect(() => {
    if (applePayLoading && !buttonLoading) {
      cancelApplePay();
    }
  }, [buttonLoading]);

  const payWithApplePay = () => {
    if (!paymentId) {
      console.log("No payment ID provided");
      return;
    }

    if (window.ApplePaySession && !applePaySession) {
      const session = new window.ApplePaySession(3, {
        countryCode: cart?.country?.code || "NL",
        currencyCode: cart?.totalPrice.currencyCode || "EUR",
        merchantCapabilities: ["supports3DS"],
        billingContact: {
          emailAddress: cart?.customerEmail || "",
        },
        supportedNetworks: ["amex", "maestro", "masterCard", "visa", "vPay"],
        total: {
          label: "Otrium",
          amount: !isProd
            ? "0.01"
            : (cart?.totalPrice.centAmount / 100).toFixed(2),
        },
      });

      setApplePayLoading(true);
      setApplePaySession(session);
      setApplePayPaymentSuccess(false);

      session.onvalidatemerchant = (event: { validationURL: any }) => {
        const validationURL = event.validationURL;

        void pspApplePaySession({
          payment_id: paymentId,
          validation_url: validationURL,
          domain: window.location.hostname,
        });
      };

      session.onpaymentauthorized = (event: { payment: any }) => {
        if (applePayPaymentSuccess) {
          // Prevent in case this event is called multiple times
          return;
        }

        const payment = event.payment;

        if (!payment.token) {
          cancelApplePay();

          session.completePayment(window.ApplePaySession.STATUS_FAILURE);

          return;
        }

        const applePayToken = JSON.stringify(payment.token);

        onClickPay(applePayToken);

        session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        setApplePayPaymentSuccess(true);
      };

      session.oncancel = () => {
        cancelApplePay();
      };

      session.begin();
    } else {
      cancelApplePay();
    }
  };

  return (
    <Button
      data-testid="checkout-order-summary-submit-button"
      variant="primary"
      fullWidth
      disabled={!!applePayLoading}
      loading={applePayLoading}
      onClick={payWithApplePay}
    >
      {label}
    </Button>
  );
};

export default ApplePayButton;
